/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/entity-areas';

export const EntityAreaApi = {
  filter: async (option: FilterEntityAreaOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterForSelect: async (option: FilterEntityAreaOptions) => {
    let url = `${pathname}/filter-for-select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInheritEntityArea: async (option: FindEntityAreaForInheritQuery) => {
    let url = `${pathname}/find-inherit-entity-area`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkExistEntityAreas: async (
    entityIDs: string[],
    entityAreaIDs: string[]
  ) => {
    const url = `${pathname}/check-exist-entity-areas`;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        entityAreaIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  syncEntityAreasInChain: async (body: any) => {
    const url = `${pathname}/sync-entity-areas`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  closeReuseDiary: async (id: string) => {
    const url = `${pathname}/close-reuse-diary/${id}`;
    try {
      const response = await entityService.patch(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityAreaOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  provinceID?: string;
  entityID?: string;
  status?: number;
}

export interface SyncEntityArea {
  entities: SyncEntityAreaEntity[];
}

interface SyncEntityAreaEntity {
  id: string;
  entityAreaIDs: string[];
}

export interface FindEntityAreaForInheritQuery {
  name?: string;
  entityID?: string;
  entityAreaID?: string;
}
